import { LinkView } from '@ekkogmbh/apisdk';
import { Chip, Typography } from '@mui/material';
import { Cancel } from '@mui/icons-material';
import React, { useMemo } from 'react';
import ChipWrapper from './ChipWrapper';
import { dataTableHighlight } from 'src/Common/Components/DataTable';

interface Props {
  link: LinkView;
  isProcessing: boolean;
  dataIndex: number;
  highlightText?: string;
  onClick: () => void;
  onDelete: () => void;
}

export const LinkChip = ({
  link,
  highlightText,
  isProcessing,
  dataIndex,
  onClick,
  onDelete,
}: Props): React.JSX.Element => {
  const label = useMemo(
    () => (
      <span style={{ position: 'relative' }}>
        <Typography
          variant={'overline'}
          align={'center'}
          color={'textPrimary'}
          display={'block'}
          style={{
            lineHeight: 'normal',
            fontWeight: 700,
            userSelect: 'text',
          }}
        >
          {dataTableHighlight(link.labelId, highlightText)}
        </Typography>

        <Typography
          variant={'overline'}
          color={'textSecondary'}
          display={'block'}
          style={{
            lineHeight: 'normal',
            fontSize: 9,
            userSelect: 'text',
            textAlign: 'center',
          }}
        >
          {dataTableHighlight(link.template.name, highlightText)}
        </Typography>
        <Typography
          variant={'overline'}
          color={'textSecondary'}
          display={'block'}
          style={{
            lineHeight: 'normal',
            fontSize: 9,
            userSelect: 'text',
            textAlign: 'center',
          }}
        >
          Page: {link.pageNumber}
        </Typography>
      </span>
    ),
    [link, highlightText],
  );

  return (
    <Chip
      component={ChipWrapper(isProcessing)}
      clickable={!isProcessing}
      data-index={dataIndex}
      variant={'outlined'}
      onClick={onClick}
      onDelete={onDelete}
      deleteIcon={
        <Cancel
          style={{
            zIndex: 1,
            cursor: isProcessing ? 'not-allowed' : 'pointer',
          }}
        />
      }
      label={label}
      sx={{
        '& .MuiChip-label': { overflow: 'visible' },
      }}
      style={{
        position: 'relative',
        margin: 8,
        height: 48,
        width: 'fit-content',
        flexShrink: 0,
        cursor: isProcessing ? 'not-allowed' : 'pointer',
      }}
    />
  );
};
